/* 运营管理（供应商、补货员、运维人员 投递员）
 */
import axios from '@/api/http'; // 导入http中创建的axios实例
import base from '@/api/base'; // 导入接口域名列表
const business = {
  /**
   * 供应商管理supplier(Supplier Controller)
   */
  // POST/supplier/page PC---分页查询供应商信息------ygt
  pageSupplier(params) {
    return axios.post(`${base.baseURL}supplier/page`, params)
  },
  //GET /supplier/query/{id} 查询------ygt
  supplier(id) {
    return axios.get(`${base.baseURL}supplier/query/${id}`)
  },
  // DELETE/supplier/remove/{id} 删除
  removeSupplier(id) {
    return axios.delete(`${base.baseURL}supplier/remove/${id}`)
  },
  // POST/supplier/save 添加/修改信息------ygt
  saveSupplier(params) {
    return axios.post(`${base.baseURL}supplier/save`, params)
  },
  // POST/supplier/supplierPagePC----根据tenantId查询供应商信息-----ygt
  supplierPage(params) {
    return axios.post(`${base.baseURL}supplier/supplierPage`, params)
  },
  /**
   * replenisher(补货员管理)Replenisher Controller
   */
  //DELETE /replenisher/delete/{id} ---pc api---删除补货员信息-------yzg
  deleteReplenisher(id) {
    return axios.delete(`${base.baseURL}replenisher/delete/${id}`)
  },
  //POST /replenisher/page ---pc api---分页展示补货员信息-------yzg
  pageReplenisher(params) {
    return axios.post(`${base.baseURL}replenisher/page`, params)
  },
  //POST /replenisher/resetPwd ---pc api---重置密码------yzg
  resetPwd(params) {
    return axios.post(`${base.baseURL}replenisher/resetPwd`, params)
  },
  //POST /replenisher/save ---pc api---新增/修改补货员-------yzg
  saveReplenisher(params) {
    return axios.post(`${base.baseURL}replenisher/save`, params)
  },
  //GET /replenisher/status/{id}/{status} ---pc api--停用/启用补货员-------yzg
  statusRep(status, id) {
    return axios.get(`${base.baseURL}replenisher/status/${id}/${status}`)
  },
  //GET /replenisher/randomPwd ---pc api---生成随机密码------yzg
  randomPwd() {
    return axios.get(`${base.baseURL}replenisher/randomPwd`)
  },
  /**
   * 运维人员
   */
  //POST /deliveryandops/saveDevOps ---pc api---新增/修改运维人员-------ygt
  saveDevOps(param) {
    return axios.post(`${base.baseURL}deliveryandops/saveDevOps`, param)
  },
  //POST /deliveryandops/devOpsPage 分页查询运维人员账户信息(运维人员姓名，公司，工号)模糊查询)------ygt
  devOpsPage(param) {
    return axios.post(`${base.baseURL}deliveryandops/devOpsPage`, param)
  },
  //POST/admin/status/{id} 启动或停用管理员账户------ygt
  statusadmin(status, id) {
    return axios.post(`${base.baseURL}admin/status/${id}?status=${status}`);
  },
  //GET /deliveryandops/randomPwd 生成随机密码------ygt
  randomPwdDel(param) {
    return axios.get(`${base.baseURL}deliveryandops/randomPwd`, param)
  },
  //DELETE /deliveryandops/remove/{id} 删除账户------ygt
  removeId(id) {
    return axios.delete(`${base.baseURL}deliveryandops/remove/${id}`)
  },
  //POST /deliveryandops/resetPwd 重置管理员账户密码------ygt
  resetPwdDel(param) {
    return axios.post(`${base.baseURL}deliveryandops/resetPwd`, param)
  },
  /**
   * 
   * @param {投递员} param 
   */
  //POST /deliveryandops/deliveryPage  分页查询投递员账户信息(投递员姓名，公司，工号)模糊查询)------ygt
  deliveryPage(param) {
    return axios.post(`${base.baseURL}deliveryandops/deliveryPage`, param)
  },
  //POST /deliveryandops/saveDelivery ---pc api---新增/修改投递人员-------ygt
  saveDelivery(param) {
    return axios.post(`${base.baseURL}deliveryandops/saveDelivery`, param)
  },
  //POST /deliveryandops/deviceUserPage 投递员下设备相关信息
  deviceUserPage(param){
    return axios.post(`${base.baseURL}deliveryandops/deviceUserPage`,param)
  },
  //POST /deliveryandops/insertDeviceUser 投递员分配设备-----ygt
  insertDeviceUser(param){
    return axios.post(`${base.baseURL}deliveryandops/insertDeviceUser`,param)
  },
  //POST /deliveryandops/listUnDeviceUser 查询未分配的设备
  listUnDeviceUser(param){
    return axios.post(`${base.baseURL}deliveryandops/listUnDeviceUser`,param)
  },
  //DELETE /deliveryandops/removeDeviceUser/{id} 移除已分配的设备-----ygt
  removeDeviceUser(id){
    return axios.delete(`${base.baseURL}deliveryandops/removeDeviceUser/${id}`)
  },
  //POST/ deliveryandops/mailgridByIdPage 投递员下查询投递记录信息
  mailgridByIdPage(param){
    return axios.post(`${base.baseURL}deliveryandops/mailgridByIdPage`,param)
  },
}
export default business;



// WEBPACK FOOTER //
// ./src/network/business.js